import React from 'react';
import { Link } from 'react-router-dom';
import projects from '../data/projectsData';
import usePageMeta from '../hooks/usePageMeta';

function ProjectsPage() {
  usePageMeta('פרויקטים', 'מבחר פרויקטים של דביר הנדסה ובניה: בתים פרטיים, מבני מגורים, בתי כנסת וישיבות, מבני תעשיה, ממ"דים וגני ילדים.');

  return (
    <div id="main">
      <section className="post page-header">
        <h1>פרויקטים נבחרים</h1>
        <p>מגוון פרויקטים המדגימים את היכולות, הניסיון והסטנדרטים הגבוהים שלנו.</p>
      </section>

      <section className="projects-grid">
        {projects.map(project => (
          <Link to={`/project/${project.slug}`} className="project-card" key={project.id}>
            <div className="project-card-image">
              <img src={project.mainImage} alt={project.title} loading="lazy" decoding="async" />
              <span className="project-card-count">
                <i className="fa fa-images"></i> {project.gallery.length} תמונות
              </span>
            </div>
            <div className="project-card-body">
              <h2>{project.title}</h2>
              <p>{project.shortDescription}</p>
              <span className="project-card-link">לפרטים נוספים <i className="fa fa-arrow-left"></i></span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}

export default ProjectsPage;
